import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from 'ddmo-storybook-lib';
import { CommonModule } from '@angular/common';

interface PopupMessageSection {
  title: string;
  items: string[];
}

interface PopupStructuredMessage {
  intro: string;
  sections: PopupMessageSection[];
  footer?: string | string[];
}

@Component({
  selector: 'app-popup',
  imports: [ButtonComponent, MatIconModule, MatDialogModule, CommonModule],
  templateUrl: `./popup.component.html`,
  styleUrl: './popup.component.scss'
})
export class PopupComponent {
  headerMessage: string = '';
  message: string | string[] | PopupStructuredMessage = '';
  constructor(private dialogRef: MatDialogRef<PopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.message = this.data?.message ? this.data.message : "";
    this.headerMessage = this.data.headerMessage ? this.data.headerMessage : this.data.isPTEDraft == true ? "Save draft" : "Alert";
  }

  isStringMessage(): boolean {
    return typeof this.message === 'string';
  }

  isListMessage(): boolean {
    return Array.isArray(this.message);
  }

  isStructuredMessage(): boolean {
    return !!this.message && typeof this.message === 'object' && 'sections' in this.message;
  }

  get stringMessage(): string {
    return typeof this.message === 'string' ? this.message : '';
  }

  get listMessage(): string[] {
    return Array.isArray(this.message) ? this.message : [];
  }

  get structuredMessage(): PopupStructuredMessage | null {
    return this.isStructuredMessage() ? (this.message as PopupStructuredMessage) : null;
  }

  get structuredFooterLines(): string[] {
    const footer = this.structuredMessage?.footer;

    if (!footer) {
      return [];
    }

    if (Array.isArray(footer)) {
      return footer.map((line: string) => `${line}`.trim()).filter((line: string) => line.length > 0);
    }

    return `${footer}`
      .split(/\r?\n/)
      .map((line: string) => line.trim())
      .filter((line: string) => line.length > 0);
  }

  formatPopupText(text: string): string {
    if (!text) {
      return '';
    }

    return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  }


  onClose() {
    this.dialogRef.close(false);
  }

  onSubmitClick() {
    this.dialogRef.close(true);
  }

}
